export default {
  'processes.title': 'My Processes',
  'processes.newProcess': 'New Process',
  'processes.cloning': 'Cloning',
  'processes.editing': 'Editing',
  'processes.creating': 'Creating',
  'processes.process': 'Process',
  'processes.name': 'Name',
  'processes.userGroups': 'User Groups',
  'processes.icon': 'Icon',
  'processes.color': 'Color',
  'processes.embedLink': 'Embed Link',
  'processes.kanban': 'Kanban',
  'processes.list': 'List',
  'processes.dashboard': 'Dashboard',
  'processes.table.code': 'Code',
  'processes.table.responsible': 'Responsible',
  'processes.table.destination': 'Destination',
  'processes.table.scheduling': 'Scheduling',
  'processes.table.completion': 'Completion',
  'processes.table.status': 'Status',
  'processes.table.priority': 'Priority',
  'processes.table.openedAt': 'Opened at',
  'processes.actionPlans.showMore': 'Show {count} more action plans',
  'processes.search.normal': 'Normal search',
  'processes.search.byReply': 'Search by reply',
  'processes.search.byAdditionalField': 'Search by additional field',
  'processes.search.byDestination': 'Search by destination',
  'processes.error.createActivity': 'Unexpected error creating activity',
  'processes.dates.title': 'Dates',
  'processes.dates.opening': 'Opening',
  'processes.dates.scheduling': 'Scheduling',
  'processes.dates.completion': 'Completion',
  'processes.dates.multiple': '{count} dates',
  'processes.validation.required': 'Required field',
  'processes.validation.invalidUrl': 'Invalid URL',
  'processes.remove.confirm': 'Are you sure you want to remove?',
  'processes.remove.success': 'Process removed successfully!',
  'processes.remove.error': 'An error occurred while removing!',
  'processes.kanban.addColumn': 'Add Column',
  'processes.welcome': 'Welcome, {name}!',
  'processes.welcomeMessage': 'See what we have prepared for you today.'
}
